var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layer_pop_wrap"
  }, [_c('div', {
    staticClass: "layer_pop_dim",
    staticStyle: {
      "background": "rgba(0, 0, 0, 0)"
    },
    style: _vm.active ? 'display: block;' : 'display: none'
  }, [_c('div', {
    staticClass: "layer_pop sm",
    class: _vm.active ? 'active' : '',
    attrs: {
      "data-role-popup": "modal_01",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "pop_head"
  }, [_c('h2', [_vm._v("활용 및 사전 등록/수정")]), _c('button', {
    staticClass: "pop_close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("닫기")])]), _c('div', {
    staticClass: "pop_cont"
  }, [_vm._m(0), _c('div', {
    staticClass: "pop_foot"
  }, [_c('button', {
    staticClass: "pop_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('utilizeProtocol', null);
      }
    }
  }, [_vm._v("활용하기")]), _c('button', {
    staticClass: "pop_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openModifyTagLayerPopup', null);
      }
    }
  }, [_vm._v("사전 등록/수정하기")])])])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form_cont"
  }, [_c('br'), _c('h3', [_vm._v("재료, 목적, 장비 노드중 한개 이상이 달라 연결이 불가능합니다.")]), _c('br'), _c('span', [_vm._v("활용")]), _c('div', {
    staticClass: "tooltip_box"
  }, [_c('span', {
    staticClass: "tooltip_ico"
  }), _c('div', {
    staticClass: "tooltip_txt"
  }, [_c('p', [_vm._v("기존 프로토콜을 활용하여 새로운 프로토콜을 생성하는 기능입니다.")])])]), _c('span', [_vm._v("또는 사전 등록/수정")]), _c('div', {
    staticClass: "tooltip_box"
  }, [_c('span', {
    staticClass: "tooltip_ico"
  }), _c('div', {
    staticClass: "tooltip_txt"
  }, [_c('p', [_vm._v("사전에 해당 재료/목적/장비를 등록 또는 수정하여 프로토콜과 연결을 완료할 수 있습니다.")])])]), _c('br'), _c('h3', [_vm._v("하시겠습니까?")]), _c('br'), _c('br')]);

}]

export { render, staticRenderFns }